import { has } from 'lodash';
import reduxStore from 'apps/web_forms/reduxStore';
import { getIdWithoutSuffix } from 'apps/web_forms/utils/inputsUtils';

import { fieldsShareSameParent } from './utils';

export const getInputMetadata = (identifier, containerFieldIdentifier) => {
  let fieldIdentifier = identifier;

  const fieldInsideRepeatGroup =
    reduxStore.getState().form.repeatGroupFields[identifier];

  if (fieldInsideRepeatGroup) {
    [fieldIdentifier] = fieldInsideRepeatGroup.filter((field) =>
      fieldsShareSameParent(field, containerFieldIdentifier)
    );
  }

  return reduxStore.getState().form.metadataInputs[fieldIdentifier] || {};
};

export const getGroupCount = (identifier, containerFieldIdentifier) => {
  let repeatGroupFields = reduxStore.getState().form.repeatGroupFields;
  let hasRepeatGroupFieldsElement = repeatGroupFields[identifier]?.filter(
    (groupId) => fieldsShareSameParent(groupId, containerFieldIdentifier)
  );
  if (hasRepeatGroupFieldsElement) {
    return hasRepeatGroupFieldsElement.length || 0;
  }

  let groupList = reduxStore.getState().form.groupList;
  return (
    groupList[identifier]?.filter((groupId) =>
      fieldsShareSameParent(groupId, containerFieldIdentifier)
    ).length || 0
  );
};

export const getIndexOf = (identifier, containerFieldIdentifier) => {
  if (containerFieldIdentifier) {
    const subformFields = reduxStore.getState().form.subformFields;
    if (subformFields[containerFieldIdentifier]) {
      return 0;
    }
    const repeatGroupFields = reduxStore.getState().form.repeatGroupFields;

    const identifiers = identifier.split('/');
    const identifiersLength = identifiers.length;
    //this check is created for groups in root level
    if (identifiersLength <= 2) {
      const identifierWithIndex = [
        ...containerFieldIdentifier.split('/').slice(0, identifiersLength - 1),
        identifiers[identifiersLength - 1],
      ].join('/');
      return (
        repeatGroupFields[identifier]?.findIndex(
          (groupField) => groupField === identifierWithIndex
        ) ?? ''
      );
    } else {
      //this check is created for nested groups. Every time a new group, that contains nested group is created, the index of the nested group will start from 0
      const containerFieldIdentifiers = containerFieldIdentifier.split('|');
      const splittedContainerIdentifiers = containerFieldIdentifiers
        .slice(0, containerFieldIdentifiers.length - 1)
        .join('|');
      const filteredIdentifiers = repeatGroupFields[identifier]?.filter(
        (groupField) => groupField.includes(splittedContainerIdentifiers)
      );
      if (filteredIdentifiers) {
        const identifierWithIndex = [
          ...containerFieldIdentifier
            .split('/')
            .slice(0, identifiersLength - 1),
          identifiers[identifiersLength - 1],
        ].join('/');
        return filteredIdentifiers.findIndex(
          (groupField) => groupField === identifierWithIndex
        ) ?? ''
      }
    }
  }
  return '';
};
